module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1201.c2857cf9.png";